import {
  DatagridConfigurable,
  List,
  TextField,
  TopToolbar,
  SelectColumnsButton,
  Pagination,
  CreateButton,
  SearchInput,
  BooleanField,
  WrapperField,
  DeleteWithConfirmButton,
} from "react-admin";

import { FILTER_LIMITS } from "@/constants/filters";
import { MODULE_NAMES } from "@/constants/modules";
import { ReferenceField } from "@/fields/ReferenceField";
import { OptionalBooleanInput } from "@/inputs/OptionalBooleanInput";
import { ReferenceSelectArrayInput } from "@/inputs/ReferenceSelectArrayInput";
import { ReferenceSelectInput } from "@/inputs/ReferenceSelectInput";

import { RadiusVpnServerPrivacyTypeField } from "./RadiusVpnServerPrivacyTypeField";

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
  </TopToolbar>
);

export const RadiusVpnServersList = () => (
  <List
    actions={<ListActions />}
    filter={{
      pagination: true,
    }}
    filters={[
      <SearchInput key="host" source="host" alwaysOn />,
      <ReferenceSelectArrayInput
        key="country"
        module={MODULE_NAMES.COUNTRIES}
        source="country[]"
        label="Countries"
        optionValue="id"
        alwaysOn
      />,
      <OptionalBooleanInput key="active" source="active" alwaysOn />,
      <OptionalBooleanInput key="alive" source="alive" alwaysOn />,
      <ReferenceSelectInput
        key="clientApps"
        module={MODULE_NAMES.CLIENT_APPS}
        source="clientApps"
        label="Client Apps"
        optionValue="id"
        sort={{ field: "deprecated", order: "ASC" }}
        alwaysOn
      />,
    ]}
    perPage={FILTER_LIMITS[0]}
    pagination={<Pagination rowsPerPageOptions={FILTER_LIMITS} />}
  >
    <DatagridConfigurable
      bulkActionButtons={false}
      omit={["createdAt", "updatedAt"]}
    >
      <TextField source="id" />
      <TextField source="ip" />
      <ReferenceField
        module={MODULE_NAMES.DATA_CENTERS}
        label="Data Center"
        source="dataCenter.id"
      />
      <ReferenceField
        module={MODULE_NAMES.COUNTRIES}
        label="Country"
        source="country.id"
      />
      <ReferenceField
        module={MODULE_NAMES.CITIES}
        label="City"
        source="city.id"
      />
      <RadiusVpnServerPrivacyTypeField source="privacyType" />
      <ReferenceField
        module={MODULE_NAMES.ACCESS_LEVELS}
        label="Access Level"
        source="accessLevel.id"
      />
      <BooleanField source="active" />
      <TextField source="host" />
      <TextField source="protocolsCsv" />
      <BooleanField source="alive" />
      <BooleanField source="autoCreated" />

      <WrapperField>
        <DeleteWithConfirmButton />
      </WrapperField>
    </DatagridConfigurable>
  </List>
);
